import styled, { css } from 'styled-components';
import { InlineText } from '@ardoq/typography';
import { Icon, IconName, IconSize, MinimalIconProps } from '@ardoq/icons';
import { pluralizeWithCount } from '@ardoq/common-helpers';
import { Container, IconContainer, Label } from './atoms';

const ChevronContainer = styled(IconContainer)<{ $isOpen?: boolean }>`
  transition: transform 0.2s ease-in-out;
  ${({ $isOpen }) =>
    $isOpen &&
    css`
      transform: rotate(180deg);
    `}
`;

type DropdownChipProps = {
  ref?: React.Ref<HTMLButtonElement>;
  label: string;
  selection: string[];
  icon?: MinimalIconProps;
  isDisabled?: boolean;
  isOpen?: boolean;
  onClick?: VoidFunction;
  'aria-controls': string;
};

export const DropdownChip = ({
  ref,
  label,
  selection,
  icon,
  isDisabled,
  isOpen,
  onClick,
  'aria-controls': ariaControls,
}: DropdownChipProps) => {
  const isActive = selection.length > 0;
  return (
    <Container
      ref={ref}
      as="button"
      type="button"
      disabled={isDisabled}
      onClick={onClick}
      aria-haspopup="listbox"
      aria-expanded={isOpen ?? false}
      aria-controls={ariaControls}
      $isActive={isActive}
      $isDisabled={isDisabled}
    >
      {icon && (
        <IconContainer>
          <Icon iconName={icon.name} iconSize={IconSize.SMALL} />
        </IconContainer>
      )}
      <InlineText variant={isActive ? 'text2Bold' : 'text2'}>
        {isActive ? `${label}:` : label}
      </InlineText>
      {isActive && (
        <Label>
          {selection.length === 1
            ? selection[0]
            : pluralizeWithCount(label.toLowerCase(), selection.length)}
        </Label>
      )}
      <ChevronContainer $isOpen={isOpen}>
        <Icon iconName={IconName.CHEVRON_DOWN} iconSize={IconSize.SMALL} />
      </ChevronContainer>
    </Container>
  );
};
